
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { ReactNode } from "react";
import { useLanguagePath } from "@/utils/language";

type StatCardProps = {
  title: string;
  value: string | number;
  description: string;
  icon: ReactNode;
  linkTo: string;
};

export const StatCard = ({
  title,
  value,
  description,
  icon,
  linkTo
}: StatCardProps) => {
  const { getPath } = useLanguagePath();
  
  return (
    <Link to={getPath(linkTo)} className="transition-transform hover:scale-[1.02] block">
      <Card className="border border-slate-100/50 dark:border-gray-700/50 shadow-md bg-white/90 dark:bg-gray-800/80 backdrop-blur-xl rounded-xl overflow-hidden h-full hover:shadow-lg transition-all">
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2 relative">
          <div className="absolute top-0 right-0 left-0 h-1 bg-gradient-to-r from-flame/40 to-flame/80 rounded-t-xl" />
          <CardTitle className="text-sm font-medium text-slate-600 dark:text-gray-300">{title}</CardTitle>
          <div className="p-2 rounded-full bg-flame/10 text-flame dark:bg-flame/20">
            {icon}
          </div>
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold text-slate-800 dark:text-gray-100">{value}</div>
          <p className="text-xs text-muted-foreground dark:text-gray-400 flex items-center mt-1">
            {description}
            <ArrowUpRight className="h-3 w-3 ml-1 text-flame" />
          </p>
        </CardContent>
      </Card>
    </Link>
  );
};
